import * as React from 'react';
type Props = {
  className?: string;
};
export function Onion({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Onion"
      className={className}
    >
      <path
        d="M21.045 8.1133C18.6864 8.21708 9.08242 7.27369 3.78984 16.9249C3.01412 18.7055 2.80337 20.6812 3.18604 22.5854C4.34645 27.8685 12.3749 32.4629 20.2335 32.1232C20.9321 32.0966 21.6285 32.0273 22.3186 31.9157C22.9601 31.8119 31.7527 30.2553 35.0264 22.9438C35.5924 21.6796 36.9132 18.8022 35.9698 15.7172C34.2056 10.1039 26.4036 7.83971 21.045 8.1133Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M18.0921 8.11328C16.5544 9.87485 15.4008 11.9376 14.7051 14.17C12.0164 22.9627 17.9316 30.8591 18.7619 31.9346"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M20.6202 8.27368C22.2753 9.94014 23.561 11.9363 24.3939 14.1323C27.5921 22.7552 22.1486 30.9723 21.3845 32.0573"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M24.1205 31.4346C30.4697 26.0477 32.0923 18.0852 28.9884 13.104C26.7054 9.4341 22.46 8.38695 21.0449 8.07562"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M17.6391 8.20764C16.2429 8.59444 12.0918 9.96243 10.0918 13.7833C7.35588 18.9721 9.53519 26.793 16.2429 31.7082"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M16.3185 35.6328L20.2714 32.0573"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M20.2714 32.0573V36.68"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M20.5166 32.095L24.2431 35.7743"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M19.3091 8.1228L20.2808 33.1139"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M28.7714 9.27369C28.7714 9.27369 21.9128 6.98122 19.3372 3C19.3372 3 15.6862 8.15104 10.2144 10.2926"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
    </svg>
  );
}
